import { Injector } from '@angular/core';
import { KeycloakService, KeycloakOptions } from 'keycloak-angular';
import { KeycloakInitOptions } from 'keycloak-js';
import { EnvService } from './services/env.service';

export function keyCloakInitializer(
  injector : Injector,
  keycloak : KeycloakService,
  env : EnvService): () => Promise<any> {

  const options: KeycloakOptions = {
    config: {
      clientId: env.keyCloakOptions.clientId,
      realm: env.keyCloakOptions.realm,
      url: env.keyCloakUrls.baseUrl
    }
  };
  //* To avoid browser from a full redirect to the Keycloak server and
  //* back to User mgmt application, instead done in a hidden iframe in the background
  const initOptions : KeycloakInitOptions  = {
    onLoad: 'check-sso',
    checkLoginIframe: true,
    checkLoginIframeInterval: 100,
    silentCheckSsoRedirectUri:
    window.location.origin + '/assets/silent-check-sso.html',
  }
  return async () => {
    try {
      await keycloak
      .init({ ...options, initOptions });
      console.log('Keycloak successfully initialized');
    } catch (e : any) {
      console.log(`keycloak init exception: ${e.error}`);
      return await Promise.reject(new Error());
    }
  };
}
